export let CLIENT_URL = ''

const SITE_URL = 'https://fm-world.it/'

switch (process.env.REACT_APP_RELEASE_ENV) {
    case 'development':
        CLIENT_URL = 'https://connect.fm-world.com/client2/'
        break
    case 'production':
        // CLIENT_URL = 'https://connect.fm-world.com/client2/'
        CLIENT_URL = 'https://connect.fm-world.com/client2/'
        break
    default:
        CLIENT_URL = 'https://connect.fm-world.com/client2/'
        break
}

export const getRadios = () => {
    return `${CLIENT_URL}radios`
}

export const getCities = () => {
    return `${CLIENT_URL}geography/cities`
}

export const getStates = () => {
    return `${CLIENT_URL}geography/states/IT`
}

export const getFmFrequencies = () => {
    return `${CLIENT_URL}frequencies`
}

export const getProvinceFromCoords = () => {
    return 'https://nominatim.openstreetmap.org/reverse'
}

export const getNews = () => {
    return `${SITE_URL}wp-json/api/custom_search`
}

export const getRandomNews = () => {
    return `${SITE_URL}wp-json/api/random`
}
